module.exports = __webpack_public_path__ + "static/media/logo_facepay_blue.a79338e4.svg";